import { render, staticRenderFns } from "./SelfAssignmentForm.vue?vue&type=template&id=63be7e9a&"
import script from "./SelfAssignmentForm.vue?vue&type=script&lang=js&"
export * from "./SelfAssignmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports